<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <p class="text-h4 text-center">About</p>

        <p class="text-h6 text-center text-blue-darken-3">AQUALYS App</p>

        <p class="text-body-1 text-left">
          This is the AQUALYS management system application. Simple but elegant!
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup></script>
